import {
  Component,
  computed,
  effect,
  input,
  model,
  signal,
} from '@angular/core';
import { CurrencyPipe, DatePipe, TitleCasePipe } from '@angular/common';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import {
  Order,
  OrderPaymentInstallment,
} from '../../../../../../../models/order.model';
import { TagStatusComponent } from '../../../../../../../../shared/components/tag-status/tag-status.component';
import { mapPaymentAttempts } from '../../../../utils/payment-attempts.util';

@Component({
  selector: 'app-order-installment-payments-dialog',
  imports: [
    DialogModule,
    TableModule,
    PaginatorModule,
    CurrencyPipe,
    DatePipe,
    TitleCasePipe,
    TagStatusComponent,
  ],
  templateUrl: './order-installment-payments-dialog.component.html',
})
export class OrderInstallmentPaymentsDialogComponent {
  visible = model(false);
  installment = input<OrderPaymentInstallment | null>(null);
  order = input<Order | null>(null);

  payments = computed(() =>
    mapPaymentAttempts(this.installment()?.payments ?? [], this.order()),
  );

  readonly first = signal(0);
  readonly rows = signal(5);

  pagedPayments = computed(() =>
    this.payments().slice(this.first(), this.first() + this.rows()),
  );

  constructor() {
    effect(() => {
      this.installment();
      this.first.set(0);
    });
  }

  onPageChange(event: PaginatorState): void {
    this.first.set(event.first ?? 0);
    this.rows.set(event.rows ?? 5);
  }

  lateFeeTotal = computed(() => {
    const installment = this.installment();
    return (
      (installment?.lateFeeAmount ?? 0) + (installment?.lateFeeTaxAmount ?? 0)
    );
  });
}
